import { render, staticRenderFns } from "./RulesPie.vue?vue&type=template&id=18b4caf4"
import script from "./RulesPie.vue?vue&type=script&lang=js"
export * from "./RulesPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports